export default __webpack_public_path__ + "static/media/icon-file-archive.9f004b23.svg";